import { css } from "styled-components";

type Spacing = string | 0 | null;
type Property = "margin" | "padding";

const _spacingStyles = (top?: Spacing, bottom?: Spacing, property: Property = "margin", override?: boolean) => {
    return css`
        ${({ theme }) => {
            const _top = typeof top === "undefined" ? 0 : top;
            const _bottom = typeof bottom === "undefined" ? theme.design?.typography.spacing.base : bottom;
            let result = "";

            if (_top !== null) {
                result += `${property}-top: ${_top}; ${
                    _top !== 0 ? `&:first-child { ${property}-top: ${override ? _top : 0}; }` : ""
                }`;
            }

            if (_bottom !== null) {
                result += `${property}-bottom: ${_bottom}; ${
                    _bottom !== 0 ? `&:last-child { ${property}-bottom: ${override ? _bottom : 0}; }` : ""
                }`;
            }

            return result;
        }}
    `;
};

export const spacingStyles = (top?: Spacing, bottom?: Spacing, property: Property = "margin") => {
    return _spacingStyles(top, bottom, property, false);
};

export const overrideSpacingStyles = (top: Spacing, bottom: Spacing, property: Property = "margin") => {
    return _spacingStyles(top, bottom, property, true);
};
